import React from "react";
import {defineBlock,ChildrenBlock, useEditor} from "@smartfire/wordpress-react";
import { InnerBlocks } from '@wordpress/block-editor';
import style from "./block.module.scss";

function Block(){
    const {isEditing} = useEditor();
    
    return <div className={isEditing ? style.blockAdmin : style.block}>
    <div className={style.content}>
        { isEditing ?<>
                <div className={style.innerBlocks}>
                    <InnerBlocks allowedBlocks={["smartfire/pictos-footer-item"]}  orientation="horizontal"/>
                </div >
            </>:
            <div className={style.itemsContainer}> 
                <div className={style.grid}> 
                    <ChildrenBlock  /> 
                </div>
            </div>
        }
    </div>
</div>
}

export default defineBlock({
    Block,
    setup: {
        title: "Pictos footer",
    }
});
